import { useLocation, useParams } from "react-router-dom";
import Axios from "../../../utils/axios";
import { useEffect, useState, useLayoutEffect, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import '../../../assets/css/AddCatalogs.css';
import AnimationLogo from "../../../components/Layout/LoadingAnimation/AnimationLogo";
import { IPracticeIndustry } from "../../../interfaces/models/IPracticeIndustry";
import GoBack from "../../../components/Moleculas/GoBack";
import Input from "../../../components/Atomos/Inputs/Input";
import FileInputButton from "../../../components/Atomos/FileInput/FileInputButton";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import Warning from "../../../components/Atomos/Icons/Warning";
import Success from "../../../components/Atomos/Icons/Success";
import MoreCircle from "../../../components/Atomos/Icons/MoreCircle";
import SaveOverride from "../../../components/Catalogs/SaveOverride";
import { addPracticeIndustry, deletePracticeIndustry, updatePracticeIndustry } from "../../../Services/PracticeIndustry";
import { UsePracticeIndustryList } from "../../../hooks/Catalogs/usePracticeIndustry";
import SvgIcon from "../../../components/ViewMode/IconComponent";
import { useDispatch } from "react-redux";
import { AddPracticeIndustry as AddPracticeIndustryAction, DeletePracticeIndustry, UpdatePracticeIndustry } from "../../../redux/catalogs/states";

interface iCatalogProps {
  mode: "add" | "edit";
}
interface IErrorState {
  nameRequired: boolean;
  fileRequired: boolean;
  nameErrorMessage?: string;
  nameDuplicated: boolean,
  nameDuplicatedMessage?: string
}

const initialErrorState: IErrorState = {
  nameRequired: false,
  fileRequired: false,
  nameErrorMessage: '',
  nameDuplicatedMessage: '',
  nameDuplicated: false,
};

const AddPracticeIndustry: React.FC<iCatalogProps> = (props) => {
  const { state, pathname } = useLocation();

  const axios = new Axios();
  const navigate = useNavigate();
  const { id } = useParams();
  const { mode } = props;
  const [buttonClicked, setButtonClicked] = useState('saveButton');
  const [errorState, setErrorState] = useState<IErrorState>(initialErrorState);
  const [newPracticeIndustry, setNewPracticeIndustry] = useState<IPracticeIndustry>()
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [imageUrl, setImageUrl] = useState(state?.icon || '');
  const [name, setName] = useState('')
  const [errorImg, setErrorImg] = useState(false)
  const [selectedFile, setSelectedFile] = useState<File | string>()
  const [fileSelected, setFileSelected] = useState(false);
  const [fileStatus, setFileStatus] = useState('Please Select a File')
  const [practiceIndustries, setPracticeIndustries] = useState<any[]>([])
  const [previousImageUrl, setPreviousImageUrl] = useState('');
  const [showSaveOverride, setShowSaveOverride] = useState(false);
  const dispatch = useDispatch();

  const { refetchPracticeIndustries } = UsePracticeIndustryList();
  const [errorFields, setErrorFields] = useState<string[]>([]);

  const attemptSaveOrUpdate = async () => {
    const errors = {
      ...initialErrorState,
      nameRequired: name === '',
      fileRequired: mode === 'add' ? !fileSelected : !fileSelected && !previousImageUrl
    };

    setErrorState(errors);

    const errorFields = Object.entries(errors)
      .filter(([key, value]) => value)
      .map(([key]) => {
        switch (key) {
          case "nameRequired":
            return "Name";
          case "fileRequired":
            return "Icon";
          default:
            return "Unknown Field";
        }
      });

    const isValid = Object.values(errors).every((error) => !error);

    if (!isValid) {
      setShowSaveOverride(true);
      setErrorFields(errorFields);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      return
    } else {
      if (mode === 'add') {
        setButtonClicked('saveButton')
      }
      else if (mode === 'edit') {
        setButtonClicked('updateButton')
      }
      setButtonClicked('saveOverride')
      handleSubmit()
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.Get('./practiceIndustry');
        const data = response.data;
        if (data != null) {
          setPracticeIndustries(data)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const handleImageUpload = async (url: string): Promise<void> => {
    try {
      const currentPracticeIndustry = newPracticeIndustry ?? state;

      if (url && currentPracticeIndustry?.id) {
        const practiceIndustry = {
          id: currentPracticeIndustry.id,
          name,
          icon: url,
          createdAt: currentPracticeIndustry.createdAt,
        }

        const response = await updatePracticeIndustry(practiceIndustry);
        dispatch(UpdatePracticeIndustry(response));
        setImageUrl(url);
        setName(String(response.name));
        setNewPracticeIndustry(response);
        fetchAndStoreIcon(response.id, url)
        await refetchPracticeIndustries()
        navigate(-1);
      }
    } catch (error: any) {
      console.log(error.message);
      setTriggerUpload(false);
    }
  };

  const fetchAndStoreIcon = async (practiceId: string, iconUrl: string) => {
    try {
      if (!iconUrl) {
        return;
      }
      const response = await fetch(iconUrl);

      const blob = await response.blob();
      const reader = new FileReader();

      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          localStorage.setItem(`practiceIndustryIcon_${practiceId}`, reader.result);
        } else {
          console.error('Conversion to Base64 did not yield a valid string.');
        }
      };

      reader.onerror = (error) => {
        console.error('Error reading blob as Base64:', error);
      };

      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error al descargar el ícono:', error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await deletePracticeIndustry(state.id);
      dispatch(DeletePracticeIndustry(state.id));
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  }
  const handleButtonClick = async (buttonName: string) => {
    setButtonClicked(buttonName);
    handleSubmit()
  };

  const handleSubmit = async () => {
    if (buttonClicked === 'updateButton') {
      await handleUpdate();
    } else if (buttonClicked === 'saveButton') {
      await handleSave();
    }
  };

  const buildPracticeIndustryObject = () => {
    return {
      id: state?.id,
      name: name,
      icon: imageUrl,
      createdAt: state.createdAt,
    };
  }

  const handleSave = useCallback(async () => {
    try {
      const practiceIndustry = buildPracticeIndustryObject();
      practiceIndustry.createdAt = new Date()
      const response = await addPracticeIndustry(practiceIndustry);
      dispatch(AddPracticeIndustryAction(response));

      setName(String(response.name))
      setNewPracticeIndustry(response)
      setTriggerUpload(true)
    } catch (error: any) {
      console.error('Error creating element:', error);
      const errors = {
        ...errorState,
        nameDuplicated: true,
        nameDuplicatedMessage: 'This value is already registered in the DB. Please input a different/new one.',
        fileRequired: true,
      }
      setErrorState(errors)
      const isValid = Object.values(errors).every((error) => !error)

      if (!isValid) {
        setTriggerUpload(false)
        setErrorImg(true)
        setSelectedFile('')
        setFileStatus('Please Select a File')
        return
      }
    }
  }, [name, selectedFile]);

  const handleUpdate = useCallback(async () => {
    const practiceIndustry: IPracticeIndustry = buildPracticeIndustryObject();
    try {
      if (fileSelected) {
        setNewPracticeIndustry(practiceIndustry)
        setTriggerUpload(true)
        return
      }

      const response = await updatePracticeIndustry(practiceIndustry);
      dispatch(UpdatePracticeIndustry(response));

      setName(String(response.name))
      setNewPracticeIndustry(response)
      await refetchPracticeIndustries()
      navigate(-1);
    } catch (error: any) {
      console.error("Error al actualizar el elemento:", error);
      const errors = {
        ...errorState,
        nameDuplicated: true,
        nameDuplicatedMessage: 'This value is already registered in the DB. Please input a different/new one.'

      }
      setErrorState(errors)
      const isValid = Object.values(errors).every((error) => !error)
      if (!isValid) {
        return
      }
      setTriggerUpload(false)
      setTriggerUpload(false)
      setErrorImg(true)
      setSelectedFile('')
      setFileStatus('Please Select a File')
    }
  }, [id, name, selectedFile]);

  const inputOnchange = (e: any) => {
    setName(e.target.value)
    setErrorState({
      ...initialErrorState,
      nameRequired: false,
      nameErrorMessage: ''
    })
  }

  useLayoutEffect(() => {
    if (mode === 'edit') {
      if (state) {
        setPreviousImageUrl(state.icon || '');
        setName(state.name);
      }
      setButtonClicked('updateButton')
    }
  }, [mode, practiceIndustries, id]);

  const handleFileSelected = (file: File) => {
    if (file.type !== 'image/svg+xml') {
      setErrorState(prevState => ({
        ...prevState,
        fileRequired: true,
      }));
      setFileStatus('Upload Failed');
      setSelectedFile(undefined);
      setFileSelected(false);
    } else {
      setErrorState(prevState => ({
        ...prevState,
        fileRequired: false,
      }));
      setFileStatus('Upload Successful');
      setSelectedFile(file);
      setFileSelected(true);
      setErrorImg(false);
    }
  };

  const handleFileRemoved = () => {
    setFileSelected(false);
  };

  const statusAttributes = () => {
    switch (fileStatus) {
      case 'Please Select a File':
        return { color: '#474F56', Icon: MoreCircle };
      case 'Upload Failed':
        return { color: '#BC3323', Icon: Warning };
      case 'Upload Successful':
        return { color: '#2AA042', Icon: Success };
      default:
        return { color: '#474F56', Icon: MoreCircle };
    }
  };

  const { color, Icon } = statusAttributes();
  const handleCloseSaveOverride = () => {
    setShowSaveOverride(false);
  };
  return (
    <>
      <main className={`${showSaveOverride && 'pt-10'}`}>
        {triggerUpload &&
          <div className="absolute top-0 left-0">
            <AnimationLogo />
          </div>
        }
        {showSaveOverride && (
          <SaveOverride
            fields={errorFields}
            open={showSaveOverride}
            close={handleCloseSaveOverride}
            handleButtonClick={(buttonClicked) => {
              handleButtonClick(buttonClicked)
            }}
          />
        )}
        <CatalogTitle title={`${props.mode === 'add' ? 'New Practice Industry' : `Edit ${state?.name}`}`} className="text-Default">
          <GoBack />
        </CatalogTitle>
        <article className='articleSection'>
          <section className="formsectionNTitle">
            <CatalogSubTitle className="text-accent-Default-dark" title=" Practice Industry Information" />
            <div className="flex flex-col gap-7 md:flex-row w-full">
              <div className="flex items-center flex-col gap-[.625rem] md:w-1/2">
                <Input
                  onChange={inputOnchange}
                  name="Name"
                  title="Name"
                  required
                  error={errorState.nameRequired}
                  errorMsj='Name is Required'
                  isWfull
                  value={name || ''}
                />
                <div className="w-full">
                  {errorState.nameDuplicated &&
                    <span className={`text-left flex flex-wrap items-center text-sm font-medium text-feedback-error`}>
                      {errorState.nameDuplicatedMessage}
                    </span>
                  }
                </div>
              </div>
              {mode === 'edit' && previousImageUrl && (
              <div className="flex flex-col w-12 h-12 lg:w-10 lg:h-10 items-center justify-center relative top-[60%] translate-y-[80%]">
                <SvgIcon practiceId={state?.id || ''} iconUrl={previousImageUrl || ''} key={state?.id ?? ''} />
                <span className="text-xs text-gray-font">Current</span>
              </div>
            )}
              <div className="flex flex-col items-center gap-4 md:gap-[.625rem] justify-start">
                <FileInputButton
                  onFileRemoved={handleFileRemoved}
                  required={true}
                  pIndustry={newPracticeIndustry?.id ?? state?.id ?? null}
                  onImageUpload={handleImageUpload}
                  triggerUpload={triggerUpload}
                  triggerDelete={errorImg}
                  onFileSelected={handleFileSelected}
                  ownerId={newPracticeIndustry?.id ?? state?.id ?? null}
                  imageCategory={name.trim()}
                />
                <div className="flex items-center gap-[.625rem] self-stretch ">
                  <span className='text-[.875rem] flex items-center justify-center'>
                    <div className={`w-6 h-6 fill-[${color}]`}>
                      <Icon />
                    </div>
                  </span>
                  <span className={`text-[${color}] text-[1rem] leading-[1.5rem] lg:text-[1.125rem] lg:leading-[2rem]`}>
                    {fileStatus}
                  </span>
                </div>
              </div>
            </div>
          </section>
          <ButtonsCrud
            Catalog="PracticeIndustry"
            mode={props.mode}
            disabled={
              errorState.nameRequired ||
              errorState.fileRequired ||
              errorState.nameDuplicated
            }
            id={id ? id : ""}
            actionButton={attemptSaveOrUpdate}
            onDelete={handleDelete}
            state={state}
            newState={buildPracticeIndustryObject()}
          />
        </article>
      </main>
    </>
  );
}
export default AddPracticeIndustry;
